import manufacturerApi from 'api/manufacturer';

const { REACT_APP_PRODUCTS_API } = process.env;
const endpoint = `${REACT_APP_PRODUCTS_API}/manufacturer/`;

export default async function getManufacturer(manufacturer: string) {
  return manufacturerApi.get(`${endpoint}${manufacturer}/`);
}
